"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var msteams_ui_styles_core_1 = require("msteams-ui-styles-core");

exports.Colors = msteams_ui_styles_core_1.Colors;
exports.getContext = msteams_ui_styles_core_1.getContext;
exports.ThemeStyle = msteams_ui_styles_core_1.ThemeStyle;

var React = require("react");

var defaultConfig = {
  baseFontSize: 10,
  style: msteams_ui_styles_core_1.ThemeStyle.Light,
  colors: msteams_ui_styles_core_1.Colors
};
var defaultContext = msteams_ui_styles_core_1.getContext(defaultConfig);
exports.TeamsThemeContext = React.createContext(defaultContext);